module.exports = __webpack_public_path__ + "img/info.2e8b44af.svg";